import { render, staticRenderFns } from "./addEditModal.vue?vue&type=template&id=6c6b7a74&"
import script from "./addEditModal.vue?vue&type=script&lang=js&"
export * from "./addEditModal.vue?vue&type=script&lang=js&"
import style0 from "./addEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports